export var MapType;
(function (MapType) {
    MapType[MapType["SATELLITE"] = 0] = "SATELLITE";
    MapType[MapType["TERRAIN"] = 1] = "TERRAIN";
    MapType[MapType["TRAFFIC"] = 2] = "TRAFFIC";
})(MapType || (MapType = {}));
